import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PriceListsPage from "./pages/PriceListsPage";
import PriceItemsPage from "./pages/PriceItemsPage";
import ApiKeysPage from "./pages/ApiKeysPage";
import LogsPage from "./pages/LogsPage";
import ChatbotContentPage from "./pages/ChatbotContentPage";
import ModelAliasesPage from "./pages/ModelAliasesPage";
import IntegrationGuidePage from "./pages/IntegrationGuidePage";
import { Toaster } from "sonner";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/fiyat-listeleri" element={<PriceListsPage />} />
                  <Route path="/fiyat-listeleri/:id" element={<PriceItemsPage />} />
                  <Route path="/model-esleştirme" element={<ModelAliasesPage />} />
                  <Route path="/chatbot-icerik" element={<ChatbotContentPage />} />
                  <Route path="/entegrasyon" element={<IntegrationGuidePage />} />
                  <Route path="/api-anahtarlari" element={<ApiKeysPage />} />
                  <Route path="/loglar" element={<LogsPage />} />
                </Routes>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
